import {
  SUBMIT_CONTENT_EDITOR_FORM,
  SUBMIT_CONTENT_EDITOR_FORM_SUCCESS,
  SUBMIT_CONTENT_EDITOR_FORM_FAILURE,
} from "@store/cms/constants";

import { makeApiCall } from "@lib/api/helpers";
import { submitContentEditorFormApi } from "@lib/api";

export const submitContentEditorForm = (values) => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: {
        type: SUBMIT_CONTENT_EDITOR_FORM,
        formName: values.formName,
      },
      success: {
        type: SUBMIT_CONTENT_EDITOR_FORM_SUCCESS,
        formName: values.formName,
      },
      fail: {
        type: SUBMIT_CONTENT_EDITOR_FORM_FAILURE,
        formName: values.formName,
      },
    },

    dispatch,
    getState,
    spinner: true,
    spinnerMessage: `Se trimite formularul...`,
    alert: true,
    alertMessage: `Nu s-a putut trimite formularul. Te rugam incearca din nou mai tarziu.`,

    apiCall: submitContentEditorFormApi,
    apiArgs: [values],

    formatResponse: (response) => response.data,
  });
};
